import type { ReactNode } from "react";
import { ChartLine, Settings2 } from "lucide-react";
import { SectionLayout } from "@/components/layout/SectionLayout";
import type { BreadcrumbItem } from "@/components/layout/SectionBar";

const ADMIN_SIDEBAR_ITEMS = [
  { id: "dashboards", label: "Dashboards", href: "/admin/dashboards", icon: ChartLine },
];

interface AdminLayoutProps {
  pageTitle: string;
  breadcrumbs?: BreadcrumbItem[];
  rightSlot?: ReactNode;
  children: ReactNode;
}

export function AdminLayout({ pageTitle, breadcrumbs, rightSlot, children }: AdminLayoutProps) {
  return (
    <SectionLayout
      sidebarKey="admin"
      sectionTitle="Management"
      sectionIcon={Settings2}
      sidebarItems={ADMIN_SIDEBAR_ITEMS}
      pageTitle={pageTitle}
      breadcrumbs={breadcrumbs}
      rightSlot={rightSlot}
    >
      {children}
    </SectionLayout>
  );
}
